export default __webpack_public_path__ + "static/media/sidebar-teal@2x.e47fa661.png";